export default __webpack_public_path__ + "static/media/universityIconoff.cf70619b.svg";